type QueryInputElement = HTMLInputElement | HTMLTextAreaElement;

const EXCLUDED_OPERATORS = ['AND', 'OR'];

export const extractQueryWordAtClick = (inputElement: QueryInputElement): string | null => {
    const inputValue = inputElement.value;

    if (!inputValue) {
        return null;
    }

    let normalizedValue = `${inputValue} `.replace(/\n/g, ' ');
    const slicedValue = normalizedValue.slice(0, normalizedValue.indexOf(' ', inputElement.selectionEnd ?? 0));
    let word = /\S+$/g.exec(slicedValue)?.[0] ?? '';

    if (inputElement.selectionStart !== inputElement.selectionEnd) {
        word = normalizedValue.slice(
            inputElement.selectionStart ?? 0,
            inputElement.selectionEnd ?? 0,
        );
    }

    if (word.includes('~')) {
        word = word.substring(0, word.indexOf('~'));
    }

    word = word.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '');
    word = word.replace('-', '');

    if (!word || EXCLUDED_OPERATORS.includes(word)) {
        return null;
    }

    return word;
};

export const getQueryWords = (queryValue: string): string[] => {
    const matches = queryValue.match(/[^\s"]+|"([^"]*)"/g) ?? [];

    return matches.map((match) => match.replace(/['"]+/g, ''));
};
